<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
    <Title :title="{name: '立项申请', path:'/item'}"></Title>


    <el-card class="box-card" style="min-height: 650px;margin-top: 15px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="150px">

        <el-divider content-position="left">项目信息</el-divider>

<!--        <el-form-item label="项目立项编号" prop="projectIden">-->
<!--          <el-input v-model="ruleForm.idenHeader"></el-input>-->
<!--        </el-form-item>-->

        <el-form-item label="项目立项编号" prop="idenHeader">
          <el-select v-model="ruleForm.idenHeader" placeholder="请选择项目编号" filterable>
            <el-option
                v-for="item in sysBaseSetList"
                :key="item.setValue"
                :label='item.setValue'
                :value="item.setValue"
            >
              <span style="float: left">{{ item.setDesc }}</span>
              <span style="float: right; margin-left: 4px; color: #8492a6; font-size: 13px">{{ item.setValue }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目名称" prop="projectName">
          <el-input v-model="ruleForm.projectName"></el-input>
        </el-form-item>


        <el-form-item label="项目负责人" prop="projectName">
          <el-select v-model="ruleForm.projectManager" placeholder="请选择项目负责人" filterable value-key="userId">
            <el-option
                v-for="item in sysUserList"
                :key="item.userId"
                :label='item.realName'
                :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="项目预计金额" prop="projectAmountExpect">
          <el-input v-model="ruleForm.projectAmountExpect" maxlength="12">
            <template slot="append">{{ getDigitUppercase }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="项目状态" prop="surveyState">
          <el-radio-group v-model="ruleForm.surveyState">
            <el-radio label="1">已沟通</el-radio>
            <el-radio label="2">已采购</el-radio>
            <el-radio label="3">已签约</el-radio>
            <el-radio label="4">已回款</el-radio>
            <el-radio label="5">已实施</el-radio>
            <el-radio label="6">项目终止</el-radio>
            <el-radio label="7">已完成</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="项目概况" prop="surveyBody">
          <el-input type="textarea" rows="5" maxlength="500"
                    show-word-limit v-model="ruleForm.surveyBody"></el-input>
        </el-form-item>

        <el-divider content-position="left">渠道信息</el-divider>

        <el-form-item label="是否通过渠道联系" prop="isChannel" required>
          <el-radio-group v-model="ruleForm.isChannel">
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-if="ruleForm.isChannel==1">
          <el-form-item label="渠道公司" prop="channelCompany">
            <el-input v-model="ruleForm.channelCompany"></el-input>
          </el-form-item>

          <el-form-item label="渠道联系人" prop="channelUserName">
            <el-input v-model="ruleForm.channelUserName"></el-input>
          </el-form-item>

          <el-form-item label="渠道联系人电话" prop="channelUserPhone">
            <el-input v-model="ruleForm.channelUserPhone"></el-input>
          </el-form-item>
        </div>

        <el-divider content-position="left">业主信息</el-divider>

        <el-form-item label="业主单位" prop="ownerCompany">
          <el-input v-model="ruleForm.ownerCompany"></el-input>
        </el-form-item>

        <el-form-item label="业主单位联系人" prop="ownerUserName">
          <el-input v-model="ruleForm.ownerUserName"></el-input>
        </el-form-item>

        <el-form-item label="业主单位联系人职位" prop="ownerUserPosition">
          <el-input v-model="ruleForm.ownerUserPosition"></el-input>
        </el-form-item>

        <el-form-item label="业主单位联系人电话" prop="ownerUserPhone">
          <el-input v-model="ruleForm.ownerUserPhone"></el-input>
        </el-form-item>

        <el-Form-item>
          <el-button v-if="submitShow" type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
        </el-Form-item>

      </el-form>


    </el-card>
  </div>


</template>

<script>
import Title from "../../Title";
import {digitUppercase, isNum} from "../../../util";
import {requestProjectApply, requestSaveSysUser, requestUserGet, requestApplyDetail, requestProjectPrefix} from "../../../api";

export default {
  components: {Title},
  name: "ProjectApply",
  data() {
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (!isNum(value)) {
        callback(new Error("请输入正确格式的金额"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额")); //防止输入多个小数点
      } else if (value.indexOf(".") > -1 && value.substring(value.indexOf(".") + 1).length > 2) {
        callback(new Error("最大保留两位小数"));
      } else if (value.length > 12) {
        callback(new Error("长度最大12个字符"))
      } else {
        this.ruleForm.projectAmountExpect = value
        callback();
      }
    };
    return {

      submitShow: true,

      sysUserList: [],
      sysBaseSetList: [],
      applyServiceId: "",
      applyType: "",
      projectId: null,
      applyId: null,
      reapply: false,
      surveyId: null,

      ruleForm: {
        idenHeader: "",
        projectName: "",
        projectManager: "",
        /**/
        projectAmountExpect: "",
        // 项目概况: "",
        surveyBody: "",
        surveyState: "1",

        /**/
        isChannel: "1",
        channelCompany: "",
        channelUserName: "",
        channelUserPhone: "",
        /**/
        ownerCompany: "",
        ownerUserName: "",
        ownerUserPosition: "",
        ownerUserPhone: "",


      },
      rules: {
        projectManager: [
          {required: true, message: '请选择项目负责人', trigger: 'blur'},
        ],
        idenHeader: [
          {required: true, message: '请输入项目立项编号', trigger: 'blur'},
          {max: 20, message: '长度最大20个字符', trigger: 'blur'}
        ],
        projectName: [
          {required: true, message: '请输入项目名称', trigger: 'blur'},
          {max: 80, message: '长度最大80个字符', trigger: 'blur'}
        ],
        projectAmountExpect: [
          {required: true, validator: validatePrice, trigger: 'blur'},
        ],
        surveyState: [
          {required: true, trigger: 'blur'},
        ],
        surveyBody: [
          {required: true, message: '请输入项目概况', trigger: 'blur'},
          {max: 500, message: '长度最大500个字符', trigger: 'blur'}
        ],
        /**/
        channelCompany: [
         /* {required: true, message: '请输入渠道公司', trigger: 'blur'},*/
          {max: 50, message: '长度最大50个字符', trigger: 'blur'}
        ],
        channelUserName: [
          {required: true, message: '请输入渠道联系人', trigger: 'blur'},
          {max: 50, message: '长度最大50个字符', trigger: 'blur'}
        ],
        channelUserPhone: [
          {required: true, message: '请输入渠道联系人电话', trigger: 'blur'},
          {max: 20, message: '长度最大20个字符', trigger: 'blur'}
        ],
        /**/
        ownerCompany: [
          {required: true, message: '请输入业主单位', trigger: 'blur'},
          {max: 20, message: '长度最大20个字符', trigger: 'blur'}
        ],
        ownerUserName: [
          {required: true, message: '请输入业主单位联系人', trigger: 'blur'},
          {max: 20, message: '长度最大20个字符', trigger: 'blur'}
        ],
        ownerUserPosition: [
          {required: true, message: '请输入业主单位联系人职位', trigger: 'blur'},
          {max: 20, message: '长度最大20个字符', trigger: 'blur'}
        ],
        ownerUserPhone: [
          {required: true, message: '请输入业主单位联系人电话', trigger: 'blur'},
          {max: 20, message: '长度最大20个字符', trigger: 'blur'}
        ]
      },

    }

  },
  computed: {
    getDigitUppercase() {
      return digitUppercase(this.ruleForm.projectAmountExpect)
    },
  },
  created() {
    this.loadSysUserData()
    this.loadSysBaseSet()
    this.applyId = this.$route.query.applyId
    this.applyServiceId = this.$route.query.applyServiceId
    this.applyType = this.$route.query.applyType
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true
      this.getObject()
    }
  },
  methods: {
    async loadSysUserData() {
      let res = await requestUserGet();
      if (res.code == 200) {
        this.sysUserList = res.object;
      } else {
        this.$message.error("获取人员列表失败")
      }
    },
    loadSysBaseSet() {
      requestProjectPrefix().then(res => {
        if (res.code == 200) {
          this.sysBaseSetList = res.object
        } else {
          this.$message.error("获取项目前缀失败")
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          if (this.ruleForm.isChannel == 2) {
            this.$delete(this.ruleForm, "channelUserPhone")
            this.$delete(this.ruleForm, "channelUserName")
            this.$delete(this.ruleForm, "channelCompany")
          }

          this.submitShow = false
          // 重新申请需要的参数
          if (this.reapply) {
            this.ruleForm.applyId = this.applyId
            this.ruleForm.projectId = this.projectId
            this.ruleForm.reapply = this.reapply
            this.ruleForm.surveyId = this.surveyId
          }

          requestProjectApply(this.ruleForm).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.resetForm('ruleForm')
              // 重新申请完之后清空路径参数
              if (this.reapply) {
                this.$router.push({query: {}})
                this.reapply = false
              }
              this.ruleForm.projectManager = ""
              this.submitShow = true
            } else {
              this.$message.error(res.msg);
              this.submitShow = true
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            let detail = res.object.detail
            let surveys = res.object.surveys[0]
            this.projectId = detail.projectId
            for (let key in this.ruleForm) {
              this.ruleForm[key] = detail[key]
            }
            this.ruleForm.projectManager = detail.projectManager
            this.ruleForm.isChannel = detail.isChannel.toString()
            this.ruleForm.projectAmountExpect = detail.projectAmountExpect.toString()
            this.ruleForm.surveyBody = surveys.surveyBody
            this.ruleForm.surveyState = surveys.surveyState.toString()
            this.ruleForm.idenHeader = detail.projectIden.substring(0,2)
            this.surveyId = surveys.surveyId
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    selectProjectManager(value) {
      console.log('选择的项目管理员',value)
      this.ruleForm.projectManager = value;
    },
  }
}
</script>

<style scoped>

</style>